import { render } from "./EditYear.vue?vue&type=template&id=62fe6acf&scoped=true"
import script from "./EditYear.vue?vue&type=script&lang=js"
export * from "./EditYear.vue?vue&type=script&lang=js"

import "./EditYear.vue?vue&type=style&index=0&id=62fe6acf&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62fe6acf"]])

export default __exports__